import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton, Switch } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import useListPriceData from "@/hooks/data/use-list-price-data";
import usePopOver from "@/hooks/use-popover";
import { IListPrice } from "@/interfaces/list-price.interface";
import { IVariation } from "@/interfaces/sku.interface";
import { ListPriceMessages } from "@/messages/listPrice/list-price.messages";

import { ListPricePopover } from "../ListPricePopover";

interface Props {
  listPrice: IListPrice;
  index: number;
  messages: ListPriceMessages;
}

export function ListPriceTableRow({ listPrice, index, messages }: Props) {
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopOver<IListPrice>();
  const data = useListPriceData(listPrice);

  const variationToText = (variations: string | IVariation[] | null): string => {
    if (!variations) return "";

    switch (typeof variations) {
      case "string": {
        try {
          const parsedVariations = JSON.parse(variations) as IVariation[];
          return parsedVariations
            .map((variation) => `${variation.VariationName} ${variation.VariationValue}`)
            .join(", ");
        } catch (e) {
          return variations;
        }
      }
      case "object": {
        if (Array.isArray(variations)) {
          return variations
            .map((variation) => `${variation.VariationName} ${variation.VariationValue}`)
            .join(", ");
        }
        return "";
      }
      default:
        return "";
    }
  };

  return (
    <TableRow index={index}>
      <TableCell>{data.code}</TableCell>
      <TableCell>{data.title}</TableCell>
      <TableCell>{data.ean}</TableCell>
      <TableCell>{variationToText(data.variations)}</TableCell>
      <TableCell>{data.formattedMainPrice}</TableCell>
      <TableCell>{data.formattedStartPromoPrice}</TableCell>
      <TableCell>{data.formattedEndPromoPrice}</TableCell>
      <TableCell>{data.formattedPromoPrice}</TableCell>
      <TableCell>
        <Switch checked={data.isActive} disabled />
      </TableCell>
      <TableCell>
        <IconButton onClick={(e) => openPopover(e, listPrice)}>
          <MoreHorizIcon />
        </IconButton>

        {selected && (
          <ListPricePopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
